
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './index.p.css';

const sizeStyles = {
  "xs": styles.sizeXS,"s": styles.sizeS,"m": styles.sizeM,"l": styles.sizeL
}

export const Size = {
  "xs": "xs","s": "s","m": "m","l": "l"
};

const Team2Icon = React.forwardRef(
  ({ theme, size, className, ...props }, ref) => {return (<svg viewBox="0 0 24 24" {...props} className={cn(styles.icon, styles[theme], sizeStyles[size], className)} ref={ref}><path d="M13.394 19.486a3.03 3.03 0 10-.214-2.47H7V9.984h6.171c.06.173.135.341.225.501A3.032 3.032 0 1013.186 8H7V3H5v14a2 2 0 002 2h6.176c.059.168.131.33.218.486z" /></svg>)}
);

Team2Icon.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["xs", "s", "m", "l"])
};

Team2Icon.defaultProps = {
  size: "m"
};

export default Team2Icon;